import { createTheme } from '@mui/material/styles';

export const createAppTheme = (mode = 'light') =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: '#1976d2',
        light: '#42a5f5',
        dark: '#1565c0',
      },
      warning: {
        main: '#BB773F',
        light: '#ffa726',
        dark: '#f57c00',
      },
      error: {
        main: '#A24D4D',
        light: '#ef5350',
        dark: '#c62828',
      },
      success: {
        main: '#4caf50',
        light: '#81c784',
        dark: '#388e3c',
      },
      background: {
        default: mode === 'dark' ? '#0f1419' : '#F5F7FA',
        paper: mode === 'dark' ? '#1a1f2e' : '#ffffff',
      },
      text: {
        primary: mode === 'dark' ? '#ffffff' : '#1a2b48',
        secondary: mode === 'dark' ? '#94a3b8' : '#64748b',
      },
      divider: mode === 'dark' ? '#2d3748' : '#e2e8f0',
      grey: {
        50: mode === 'dark' ? '#1a1f2e' : '#f8fafc',
        100: mode === 'dark' ? '#151a24' : '#f1f5f9',
        200: mode === 'dark' ? '#2d3748' : '#e2e8f0',
        300: mode === 'dark' ? '#3d4a5c' : '#cbd5e1',
      },
    },
    typography: {
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
    },
  });

const theme = createAppTheme('light');

export default theme;
